function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SaitoVideoBox = require('../../../../lib/saito/ui/saito-videobox/video-box');
var CallInterfaceVideoTemplate = require('./call-interface-video.template');
var Effects = require('../overlays/effects');
var VideocallSettings = require('../overlays/videocall-settings');
var StreamMirror = require('./stream-mirror');
var CallInterfaceVideo = /*#__PURE__*/function () {
  function CallInterfaceVideo(app, mod) {
    var _this = this;
    var fullScreen = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    _classCallCheck(this, CallInterfaceVideo);
    this.app = app;
    this.mod = mod;
    this.videocall_settings = new VideocallSettings(app, mod);
    this.effectsMenu = new Effects(app, mod);
    this.localStream;
    this.video_boxes = {};
    this.local_container = 'expanded-video';
    this.remote_container = 'side-videos';
    this.remote_streams = new Map();
    this.current_speaker = null;
    this.speaker_candidate = null;
    this.public_key = mod.publicKey;
    this.full_screen = fullScreen;
    this.rendered = false;

    //
    // Stable display order (join sequence) and current holder of the
    // large window in split (focus/speaker) layouts
    //
    this.peer_order = [];
    this.expanded_peer = null;
    this.app.connection.on('show-call-interface', /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(videoEnabled, audioEnabled) {
        var room_link;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              console.info('TALK [show-call-interface]', videoEnabled, audioEnabled);

              //This will render the (full-screen) component
              if (!document.querySelector('.stun-chatbox')) {
                _this.render(videoEnabled, audioEnabled);
              }
              if (!_this.old_title) {
                _this.old_title = document.title;
              }
              room_link = _this.mod.generateCallLink();
              if (_this.full_screen) {
                window.history.pushState({}, '', room_link);
                document.title = 'Saito Talk';
              }
            case 1:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }());
    this.app.connection.on('stun-update-link', function () {
      var room_link = _this.mod.generateCallLink();
      if (_this.full_screen) {
        window.history.replaceState({}, '', room_link);
        document.title = 'Saito Talk';
      }
    });
    this.app.connection.on('add-local-stream-request', function (localStream) {
      _this.addLocalStream(localStream);
    });
    this.app.connection.on('add-remote-stream-request', function (peer, remoteStream) {
      _this.remote_streams.set(peer, remoteStream);
      _this.addRemoteStream(peer, remoteStream);
      _this.updateImages();
      if (remoteStream) {
        _this.startTimer();
      }
    });
    this.app.connection.on('add-waiting-video-box', function () {
      _this.addRemoteStream('connecting', null);
    });
    this.app.connection.on('remove-waiting-video-box', function () {
      var _this$video_boxes$pee;
      var peer_id = 'connecting';
      if ((_this$video_boxes$pee = _this.video_boxes[peer_id]) !== null && _this$video_boxes$pee !== void 0 && _this$video_boxes$pee.video_box) {
        _this.video_boxes[peer_id].video_box.destroy();
        delete _this.video_boxes[peer_id];
      }
    });
    this.app.connection.on('remove-peer-box', function (peer_id) {
      var _this$video_boxes$pee2;
      _this.remote_streams["delete"](peer_id);
      if ((_this$video_boxes$pee2 = _this.video_boxes[peer_id]) !== null && _this$video_boxes$pee2 !== void 0 && _this$video_boxes$pee2.video_box) {
        _this.video_boxes[peer_id].video_box.destroy();
        delete _this.video_boxes[peer_id];
        _this.updateImages();
      }
      if (_this.expanded_peer === peer_id) {
        _this.expanded_peer = null;
      }

      //
      // Reflow the remaining boxes in place -- no layout rebuild, no toast
      //
      _this.setDisplayContainers();
    });

    // Change arrangement of video boxes (emitted from SwitchDisplay overlay)
    app.connection.on('stun-switch-view', function () {
      var newView = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var noMessage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (newView && !noMessage) {
        siteMessage("Switched to ".concat(newView, " display"), 2000);
      }
      if (newView == 'presentation') {
        newView = 'focus';
      }
      if (newView) {
        _this.mod.layout = newView;
      }
      switch (_this.mod.layout) {
        case 'gallery':
          _this.switchDisplayToGallery();
          break;
        case 'speaker':
          _this.switchDisplayToExpanded();
          break;
        case 'focus':
          _this.switchDisplayToExpanded();
      }
    });
    app.connection.on('stun-new-speaker', function (peer) {
      if (!_this.full_screen) {
        return;
      }
      document.querySelectorAll('.saito-videobox').forEach(function (item) {
        if (item.id === "stream".concat(peer)) {
          if (item.classList.contains('speaker')) {
            return;
          }
          if (_this.mod.layout == 'speaker' && !item.parentElement.classList.contains('expanded-video')) {
            console.debug('TALK [stun-new-speaker]: ' + peer);
            _this.flipDisplay(peer);
          }
          item.classList.add('speaker');
        } else {
          item.classList.remove('speaker');
        }
      });
    });
    app.connection.on('videocall-show-settings', function () {
      _this.videocall_settings.render();
    });
    app.connection.on('videocall-connection-strength', function (peer, mos) {
      mos = Math.floor(mos);
      if (_this.video_boxes[peer]) {
        if (_this.video_boxes[peer].connection_strength == mos) {
          return;
        }
        _this.video_boxes[peer].connection_strength = mos;
        _this.video_boxes[peer].video_box.addConnectionStrength(mos);
      }
    });
    app.connection.on('stun-data-channel-open', function (pkey) {
      if (_this.rendered) {
        //this.insertActions(this.mod.room_obj.call_peers);
      }
    });
  }
  return _createClass(CallInterfaceVideo, [{
    key: "close",
    value: function close() {
      for (var peer in this.video_boxes) {
        this.app.connection.emit('remove-peer-box', peer);
      }
      if (this.old_title) {
        document.title = this.old_title;
        delete this.old_title;
      }
      this.app.connection.emit('interrupt-screen-recording');
      if (this.mod.browser_active) {
        var _this$app$options;
        var homeModule = ((_this$app$options = this.app.options) === null || _this$app$options === void 0 ? void 0 : _this$app$options.homeModule) || this.name;
        var mod = this.app.modules.returnModuleByName(homeModule);
        var slug = (mod === null || mod === void 0 ? void 0 : mod.returnSlug()) || 'videocall';
        var url = '/' + slug;
        navigateWindow(url, 2000);
      } else {
        //
        // Hopefully we don't have to reload the page on the end of a stun call
        // But keep on eye on this for errors and make sure all the components shut themselves down properly
        //
        if (document.querySelector('.stun-overlay-container')) {
          document.querySelector('.stun-overlay-container').remove();
          if (this.full_screen) {
            window.history.back();
          }
        }
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _this$streamMirror;
      console.debug('TALK.destroy');
      this.app.connection.removeAllListeners('show-call-interface');
      this.app.connection.removeAllListeners('stun-update-link');
      this.app.connection.removeAllListeners('add-local-stream-request');
      this.app.connection.removeAllListeners('add-remote-stream-request');
      this.app.connection.removeAllListeners('add-waiting-video-box');
      this.app.connection.removeAllListeners('remove-waiting-video-box');
      this.app.connection.removeAllListeners('remove-peer-box');
      this.app.connection.removeAllListeners('stun-switch-view');
      this.app.connection.removeAllListeners('stun-new-speaker');
      this.app.connection.removeAllListeners('videocall-show-settings');
      this.app.connection.removeAllListeners('videocall-connection-strength');
      this.app.connection.removeAllListeners('stun-data-channel-open');
      this.app.connection.removeAllListeners('toggle-screen-share-label');
      this.stopTimer();

      //
      // close() normally destroys the boxes, but reset-stun can call destroy()
      // directly -- make sure their listeners are unhooked either way
      //
      for (var peer in this.video_boxes) {
        var _this$video_boxes$pee3;
        if ((_this$video_boxes$pee3 = this.video_boxes[peer]) !== null && _this$video_boxes$pee3 !== void 0 && (_this$video_boxes$pee3 = _this$video_boxes$pee3.video_box) !== null && _this$video_boxes$pee3 !== void 0 && _this$video_boxes$pee3.destroy) {
          this.video_boxes[peer].video_box.destroy();
        }
        delete this.video_boxes[peer];
      }
      this.rendered = false;
      this === null || this === void 0 || (_this$streamMirror = this.streamMirror) === null || _this$streamMirror === void 0 || _this$streamMirror.destroy();
    }
  }, {
    key: "render",
    value: function render(videoEnabled, audioEnabled) {
      if (!document.querySelector('#stun-chatbox')) {
        this.app.browser.addElementToDom(CallInterfaceVideoTemplate(this.mod, videoEnabled, audioEnabled));

        //stun-overlay-container make

        this.insertActions();
        this.attachEvents();
      }
      if (document.querySelector('.game-video-container')) {
        if (!(this !== null && this !== void 0 && this.streamMirror)) {
          this.streamMirror = new StreamMirror(this.app, this.mod);
        }
      }
      if (!this.mod.browser_active) {
        this.app.connection.emit('stun-switch-view', 'gallery', true);
      } else {
        this.app.connection.emit('stun-switch-view', this.mod.layout, true);
      }
      if (!this.full_screen) {
        try {
          document.querySelector('.stun-chatbox .minimizer').click();
        } catch (err) {
          console.error('TALK.callInterface Error: ', err);
        }
      }

      // Keep a local tile available even when capture fails before a stream exists.
      this.createVideoBox('local', this.local_container);
      this.setDisplayContainers();
      this.rendered = true;
    }
  }, {
    key: "insertActions",
    value: function insertActions() {
      var _this2 = this;
      // add call icons

      var container = document.querySelector('.control-list.imported-actions');
      if (!container) {
        return;
      }
      container.innerHTML = '';
      var index = 0;
      var streams = [this.localStream];
      this.remote_streams.forEach(function (stream, key) {
        streams.push(stream);
      });
      var _iterator = _createForOfIteratorHelper(this.app.modules.mods),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var mod = _step.value;
          var item = mod.respondTo('call-actions', {
            call_id: this.mod.room_obj.call_id
          });
          if (item instanceof Array) {
            item.forEach(function (j) {
              _this2.createActionItem(j, container, index++);
            });
          } else if (item != null) {
            this.createActionItem(item, container, index++);
          }

          // This should confirm to the standard API!

          item = mod.respondTo('record-actions', {
            container: '.video-container-large',
            streams: streams,
            useMicrophone: true,
            members: this.mod.room_obj.call_peers,
            callbackAfterRecord: function callbackAfterRecord(data) {
              console.debug('callbackAfterRecord', data);
            }
          });
          if (item instanceof Array) {
            item.forEach(function (j) {
              _this2.createActionItem(j, container, index++);
            });
          } else if (item != null) {
            this.createActionItem(item, container, index++);
          }
        }

        /*
        <span class="record-control icon_click_area" id="record-icon">
         <label>Record</label>
         <i class="fa-solid fa-record-vinyl"></i>
        </span>
        */
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "createActionItem",
    value: function createActionItem(item, container, index) {
      var _this3 = this;
      var id = 'call_action_item_' + index;
      var hook = (item === null || item === void 0 ? void 0 : item.hook) || '';
      var html = "<div id=\"".concat(id, "\" class=\"icon_click_area ").concat(hook, "\">\n\t\t\t\t\t\t<label>").concat(item.text, "</label>\n\t\t\t\t\t\t<i class=\"").concat(item.icon, "\"></i>\n\t\t\t\t\t</div>");
      var el = document.createElement('div');
      if (item !== null && item !== void 0 && item.prepend) {
        container.prepend(el);
      } else {
        container.appendChild(el);
      }
      el.outerHTML = html;
      var div = document.getElementById(id);
      if (div) {
        if (item !== null && item !== void 0 && item.callback) {
          div.onclick = function () {
            item.callback(_this3.app, _this3.mod.room_obj);
          };
        } else {
          console.warn('TALK.callInterface: Adding an action item with no callback');
        }
        if (item.event) {
          item.event(id);
        }
      } else {
        console.warn('TALK.callInterface: Item not found');
      }
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this4 = this;
      var add_users = document.querySelector('.users-on-call .invite-control');
      if (add_users) {
        add_users.addEventListener('click', function (e) {
          _this4.mod.copyInviteLink();
        });
        add_users.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            _this4.mod.copyInviteLink();
          }
        });
      }
      if (document.querySelector('.effects-control')) {
        document.querySelector('.effects-control').addEventListener('click', function (e) {
          _this4.effectsMenu.render();
        });
      }
      document.querySelectorAll('.disconnect-control').forEach(function (item) {
        item.addEventListener('click', /*#__PURE__*/function () {
          var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(e) {
            return _regenerator().w(function (_context2) {
              while (1) switch (_context2.n) {
                case 0:
                  _this4.app.connection.emit('stun-disconnect');
                  siteMessage('You have been disconnected', 3000);
                case 1:
                  return _context2.a(2);
              }
            }, _callee2);
          }));
          return function (_x3) {
            return _ref2.apply(this, arguments);
          };
        }());
      });

      /*document.getElementById('record-icon').onclick = async () => {
      const recordIcon = document.querySelector('#record-icon i');
      const recordLabel = document.querySelector('#record-icon label');
      const formatTime = (totalSeconds) => {
      const hours = Math.floor(totalSeconds / 3600)
      	.toString()
      	.padStart(2, '0');
      const minutes = Math.floor((totalSeconds % 3600) / 60)
      	.toString()
      	.padStart(2, '0');
      const seconds = (totalSeconds % 60).toString().padStart(2, '0');
      return `${hours}:${minutes}:${seconds}`;
      };
      if (this.mod.peerManager.recording === true) {
      console.log('stopping recording');
      this.mod.peerManager.stopRecordCall();
      	clearInterval(this.recordingInterval);
      	recordLabel.textContent = 'Record';
      recordIcon.classList.remove('recording');
      } else {
      let recording = await this.mod.peerManager.recordCall();
      if (!recording) return;
      let totalSeconds = 0;
      recordLabel.textContent = '00:00:00';
      this.recordingInterval = setInterval(() => {
      	totalSeconds++;
      	recordLabel.textContent = `${formatTime(totalSeconds)}`;
      }, 1000);
      	recordIcon.classList.add('recording');
      }
      };*/

      document.querySelectorAll('.call-controls .video-control').forEach(function (item) {
        item.onclick = function () {
          _this4.toggleVideo();
        };
      });
      document.querySelectorAll('.call-controls .audio-control').forEach(function (item) {
        item.onclick = function () {
          _this4.toggleAudio();
        };
      });
      if (!this.mod.browser_active) {
        //
        // If you are in RedSquare/Arcade/etc, allow stun to shrink down to small box so you
        // can still interact with the site
        //

        document.querySelector('.stun-chatbox .minimizer').addEventListener('click', function (e) {
          // fas fa-expand"
          var icon = document.querySelector('.stun-chatbox .minimizer i');
          var chat_box = document.querySelector('.stun-overlay-container');
          if (icon.classList.contains('fa-caret-down')) {
            if (_this4.mod.layout == 'focus') {
              // Make sure that I am not staring at myself in local!
              // >>>>>>>>>>>
              /*if (remoteStream) {
              let peer_elem = document.getElementById(`stream_${peer}`);
              if (peer_elem) {
              peer_elem.querySelector('.video-box').click();
              }
              }*/
            }
            chat_box.classList.add('minimize');
            icon.classList.remove('fa-caret-down');
            icon.classList.add('fa-expand');
            _this4.app.browser.makeDraggable('stun-chatbox-box', '', true);
            _this4.full_screen = false;
          } else {
            chat_box.classList.remove('minimize');
            chat_box.style.top = '';
            chat_box.style.bottom = '0';
            chat_box.style.left = '0';
            chat_box.style.width = '';
            chat_box.style.height = '';
            icon.classList.remove('fa-expand');
            icon.classList.add('fa-caret-down');
            _this4.app.browser.cancelDraggable('stun-chatbox-box');
            _this4.full_screen = true;
          }
        });
      } else {
        //
        // If in the stun app, all a request for full screen mode
        //
        var maximizer = document.querySelector('.stun-chatbox .maximizer');
        if (maximizer) {
          maximizer.onclick = function (e) {
            _this4.app.browser.requestFullscreen();
          };
        }
      }
      document.querySelector('.video-container-large').addEventListener('click', function (e) {
        if (_this4.mod.layout == 'gallery') {
          return;
        }
        if (e.target.classList.contains('video-box')) {
          var stream_id = e.target.id;
          if (e.target.parentElement.parentElement.classList.contains(_this4.local_container)) {
            return;
          } else {
            _this4.flipDisplay(stream_id);
          }
        }
      });
    }
  }, {
    key: "flipDisplay",
    value: function flipDisplay(stream_id) {
      //
      // gallery has no large slot
      //
      if (this.local_container === this.remote_container) {
        return;
      }
      if (!this.video_boxes[stream_id] || this.expanded_peer === stream_id) {
        return;
      }
      this.expanded_peer = stream_id;
      this.setDisplayContainers();
    }
  }, {
    key: "addRemoteStream",
    value: function addRemoteStream(peer, remoteStream) {
      this.createVideoBox(peer);
      this.video_boxes[peer].video_box.render(remoteStream);
      this.updateImages();
      if (peer.toLowerCase() === 'presentation') {
        // switch mode to presentation
        this.app.connection.emit('stun-switch-view', 'presentation');
        this.flipDisplay('presentation');
      } else if (remoteStream && peer !== 'local' && peer !== 'connecting' && (!this.expanded_peer || this.expanded_peer === 'local')) {
        //
        // In focus/speaker layouts the counterparty belongs in the large
        // window -- promote the first remote peer whose stream arrives
        //
        this.flipDisplay(peer);
      }
      this.setDisplayContainers();
    }
  }, {
    key: "addLocalStream",
    value: function addLocalStream(localStream) {
      this.localStream = localStream;
      this.createVideoBox('local', this.local_container);
      this.video_boxes['local'].video_box.render(localStream);
      this.updateImages();
      this.setDisplayContainers();

      // segmentBackground(document.querySelector('#stream_local video'), document.querySelector('#stream_local canvas'), 1);
      // applyBlur(7);
    }
  }, {
    key: "createVideoBox",
    value: function createVideoBox(peer) {
      var container = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.remote_container;
      if (!this.video_boxes[peer]) {
        console.info('TALK [createVideoBox]: ', peer);
        var videoBox = new SaitoVideoBox(this.app, this.mod, peer, container);
        this.video_boxes[peer] = {
          video_box: videoBox
        };
      }
    }
  }, {
    key: "toggleAudio",
    value: function toggleAudio() {
      //Tell PeerManager to adjust streams
      this.app.connection.emit('stun-toggle-audio');

      //Update UI
      try {
        document.querySelector('.call-controls .audio-control').classList.toggle('disabled');
        document.querySelector('.call-controls .audio-control i').classList.toggle('fa-microphone-slash');
        document.querySelector('.call-controls .audio-control i').classList.toggle('fa-microphone');
      } catch (err) {
        console.error('Talk.callInterface [toggleAudio] Error:', err);
      }
    }
  }, {
    key: "toggleVideo",
    value: function toggleVideo() {
      this.app.connection.emit('stun-toggle-video');

      //Update UI
      try {
        document.querySelector('.call-controls .video-control').classList.toggle('disabled');
        document.querySelector('.call-controls .video-control i').classList.toggle('fa-video-slash');
        document.querySelector('.call-controls .video-control i').classList.toggle('fa-video');
      } catch (err) {
        console.error('Talk.callInterface [toggleVideo] Error', err);
      }
    }
  }, {
    key: "updateImages",
    value: function updateImages() {
      var images = "";
      var imageDiv = document.querySelector('.users-on-call .stun-identicon-list');
      if (!imageDiv) {
        return;
      }
      for (var publickey in this.video_boxes) {
        if (publickey === 'presentation') {
          continue;
        }
        if (publickey === 'local') {
          publickey = this.mod.publicKey;
        }
        var imgsrc = this.app.keychain.returnIdenticon(publickey);
        images += "<img data-id =\"".concat(publickey, "\" class=\"saito-identicon\" src=\"").concat(imgsrc, "\"/>");
      }
      imageDiv.innerHTML = images;
    }
  }, {
    key: "startTimer",
    value: function startTimer() {
      if (this.timer_interval) {
        return;
      }
      var timerElement = document.querySelector('.stun-chatbox .counter');
      var seconds = 0;
      var timer = function timer() {
        seconds++;

        // Get hours
        var hours = Math.floor(seconds / 3600);
        // Get minutes
        var minutes = Math.floor((seconds - hours * 3600) / 60);
        // Get seconds
        var secs = Math.floor(seconds % 60);
        if (hours > 0) {
          hours = "0".concat(hours, ":");
        } else {
          hours = '';
        }
        if (minutes < 10) {
          minutes = "0".concat(minutes);
        }
        if (secs < 10) {
          secs = "0".concat(secs);
        }
        timerElement.innerHTML = "".concat(hours).concat(minutes, ":").concat(secs);
      };
      this.timer_interval = setInterval(timer, 1000);
    }
  }, {
    key: "stopTimer",
    value: function stopTimer() {
      clearInterval(this.timer_interval);
      this.timer_interval = null;
    }
  }, {
    key: "switchDisplayToGallery",
    value: function switchDisplayToGallery() {
      this.local_container = 'gallery';
      this.remote_container = 'gallery';
      this.applyLayout();
    }
  }, {
    key: "switchDisplayToExpanded",
    value: function switchDisplayToExpanded() {
      this.local_container = 'expanded-video';
      this.remote_container = 'side-videos';
      this.applyLayout();
    }

    //
    // Re-class the two persistent wrapper divs for the active layout instead of
    // rebuilding them -- the live <video> elements are moved, never recreated
    //
  }, {
    key: "applyLayout",
    value: function applyLayout() {
      var _primary$classList, _secondary$classList;
      var container = document.querySelector('.video-container-large');
      if (!container) {
        return;
      }
      var primary = container.querySelector('.videocall-primary');
      var secondary = container.querySelector('.videocall-secondary');
      if (!primary || !secondary) {
        return;
      }
      var layout_classes = ['hidden', 'gallery', 'expanded-video', 'side-videos', 'presentation', 'presentation-side-videos'];
      (_primary$classList = primary.classList).remove.apply(_primary$classList, layout_classes);
      (_secondary$classList = secondary.classList).remove.apply(_secondary$classList, layout_classes);

      //
      // Clear inline sizing left behind by applyGalleryGrid -- the same
      // wrapper becomes a flex film strip in split layouts
      //
      for (var _i = 0, _arr = [primary, secondary]; _i < _arr.length; _i++) {
        var el = _arr[_i];
        el.style.gridTemplateColumns = '';
        el.style.justifyContent = '';
        el.style.alignContent = '';
        el.style.overflowY = '';
      }
      if (this.local_container === this.remote_container) {
        container.classList.remove('split-view', 'expanded', 'presentation');
        container.classList.add('gallery-view');
        primary.classList.add('hidden');
        secondary.classList.add(this.remote_container);
      } else {
        container.classList.remove('gallery-view', 'presentation');
        container.classList.add('split-view', 'expanded');
        primary.classList.add(this.local_container);
        secondary.classList.add(this.remote_container);
      }
      this.setDisplayContainers();
    }
  }, {
    key: "setDisplayContainers",
    value: function setDisplayContainers() {
      var _this5 = this;
      var container = document.querySelector('.video-container-large');
      if (!container) {
        return;
      }
      var split_mode = this.local_container !== this.remote_container;

      //
      // Make sure someone sensible holds the large window in split layouts
      //
      if (split_mode && (!this.expanded_peer || !this.video_boxes[this.expanded_peer])) {
        this.expanded_peer = this.defaultExpandedPeer();
      }
      for (var i in this.video_boxes) {
        var vb = this.video_boxes[i].video_box;
        vb.containerClass = split_mode && i === this.expanded_peer ? this.local_container : this.remote_container;
        vb.render(i === 'local' ? this.localStream : this.remote_streams.get(i));
        this.placeBox(i);
        if (i !== 'local' && this.video_boxes[i].connection_strength) {
          vb.addConnectionStrength(this.video_boxes[i].connection_strength);
        }
      }
      container.querySelectorAll('.videocall-primary, .videocall-secondary').forEach(function (c) {
        return _this5.setupContainer(c);
      });
      document.querySelectorAll('.saito-videobox').forEach(function (item) {
        _this5.resizeBackground(item);
      });
    }
  }, {
    key: "defaultExpandedPeer",
    value: function defaultExpandedPeer() {
      if (this.video_boxes['presentation']) {
        return 'presentation';
      }

      //
      // focus layout: show the counterparty large, not ourselves
      //
      var _iterator2 = _createForOfIteratorHelper(this.peer_order),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var peer = _step2.value;
          if (this.video_boxes[peer]) {
            return peer;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return this.video_boxes['local'] ? 'local' : null;
    }
  }, {
    key: "orderIndex",
    value: function orderIndex(id) {
      if (id === 'presentation') return -2;
      if (id === 'local') return -1;
      if (id === 'connecting') return Number.MAX_SAFE_INTEGER;
      var idx = this.peer_order.indexOf(id);
      if (idx === -1) {
        idx = this.peer_order.length;
        this.peer_order.push(id);
      }
      return idx;
    }

    //
    // Keep boxes in stable join order so tiles don't shuffle when peers come
    // and go; only touch the DOM when an element is actually out of place
    //
  }, {
    key: "placeBox",
    value: function placeBox(id) {
      var _this$video_boxes$id;
      var vb = (_this$video_boxes$id = this.video_boxes[id]) === null || _this$video_boxes$id === void 0 ? void 0 : _this$video_boxes$id.video_box;
      var box = document.getElementById("stream_".concat(id));
      if (!(vb !== null && vb !== void 0 && vb.containerClass) || !box) {
        return;
      }
      var target = document.querySelector(".video-container-large .".concat(vb.containerClass));
      if (!target) {
        return;
      }
      var myIdx = this.orderIndex(id);
      var before = null;
      var _iterator3 = _createForOfIteratorHelper(target.children),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var child = _step3.value;
          if (child === box) {
            continue;
          }
          if (this.orderIndex((child.id || '').replace('stream_', '')) > myIdx) {
            before = child;
            break;
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      if (box.parentElement !== target || box.nextElementSibling !== before) {
        target.insertBefore(box, before);
      }
      box.classList.add('flex-item');
    }
  }, {
    key: "setupContainer",
    value: function setupContainer(container) {
      Array.from(container.children).forEach(function (child) {
        child.classList.add('flex-item');
      });
      this.updateCountClasses(container);
      this.applyGalleryGrid(container);
      this.adjustClassesAndCount(container);
    }

    //
    // Best-fit gallery: pick the column count that maximizes tile size for
    // the current stage dimensions and participant count. Handles vertical
    // monitors for free (the math just yields fewer columns, more rows).
    // Tile aspect must stay in sync with the CSS aspect-ratio rules.
    //
  }, {
    key: "applyGalleryGrid",
    value: function applyGalleryGrid(container) {
      if (!(container !== null && container !== void 0 && container.classList.contains('gallery'))) {
        return;
      }
      var n = container.children.length;
      var cs = window.getComputedStyle(container);
      var gap = parseFloat(cs.gap) || 0;
      var W = container.clientWidth - (parseFloat(cs.paddingLeft) || 0) - (parseFloat(cs.paddingRight) || 0);
      var H = container.clientHeight - (parseFloat(cs.paddingTop) || 0) - (parseFloat(cs.paddingBottom) || 0);
      if (!n || W <= 0 || H <= 0) {
        return;
      }
      var mobile = window.matchMedia('(max-width: 600px)').matches;
      var aspect = mobile ? 3 / 4 : 4 / 3;
      var best_cols = 1;
      var best_width = 0;
      for (var cols = 1; cols <= n; cols++) {
        var _rows = Math.ceil(n / cols);
        var usable_w = W - gap * (cols - 1);
        var usable_h = H - gap * (_rows - 1);
        var tile_w = Math.min(usable_w / cols, usable_h / _rows * aspect);
        if (tile_w > best_width) {
          best_width = tile_w;
          best_cols = cols;
        }
      }

      //
      // Don't shrink tiles into postage stamps in a crowded call -- clamp
      // to a minimum size and let the container scroll vertically instead
      //
      var min_width = mobile ? W * 0.42 : 220;
      if (best_width < min_width) {
        best_cols = Math.max(1, Math.floor((W + gap) / (min_width + gap)));
        best_width = (W - gap * (best_cols - 1)) / best_cols;
      }
      var rows = Math.ceil(n / best_cols);
      var overflowing = rows * (best_width / aspect + gap) - gap > H;
      container.style.gridTemplateColumns = "repeat(".concat(best_cols, ", ").concat(Math.floor(best_width), "px)");
      container.style.justifyContent = 'center';
      container.style.alignContent = overflowing ? 'start' : 'center';
      container.style.overflowY = overflowing ? 'auto' : 'hidden';
    }
  }, {
    key: "updateCountClasses",
    value: function updateCountClasses(element) {
      var childCount = element.children.length;
      Array.from(element.classList).forEach(function (className) {
        if (className.startsWith('count-')) {
          element.classList.remove(className);
        }
      });
      element.classList.add("count-".concat(childCount));
    }
  }, {
    key: "adjustClassesAndCount",
    value: function adjustClassesAndCount(element) {
      var _this6 = this;
      //
      // Containers persist for the life of the call now -- one observer each,
      // not one per render
      //
      if (element._sizing_observer) {
        return;
      }
      var observer = new ResizeObserver(function (entries) {
        var _iterator4 = _createForOfIteratorHelper(entries),
          _step4;
        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var entry = _step4.value;
            var width = entry.contentRect.width;
            var height = entry.contentRect.height;
            var aspectRatio = width / height;
            element.classList.remove('wide', 'tall', 'square');
            if (aspectRatio > 5 / 3) {
              element.classList.add('wide');
            } else if (aspectRatio < 4 / 5) {
              element.classList.add('tall');
            } else {
              element.classList.add('square');
            }
            _this6.updateCountClasses(element);
            _this6.applyGalleryGrid(element);
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
      });
      observer.observe(element);
      element._sizing_observer = observer;
    }

    //
    // Track each tile's orientation so CSS can decide between cropping and
    // letterboxing the feed (see the tile-landscape/tile-portrait rules)
    //
  }, {
    key: "resizeBackground",
    value: function resizeBackground(element) {
      if (element._bg_observer) {
        return;
      }
      var bg_observer = new ResizeObserver(function (entries) {
        var _iterator5 = _createForOfIteratorHelper(entries),
          _step5;
        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var entry = _step5.value;
            var _element = entry.target;
            var aspectRatio = entry.contentRect.width / entry.contentRect.height;
            _element.classList.remove('tile-landscape', 'tile-portrait');
            _element.classList.add(aspectRatio >= 1 ? 'tile-landscape' : 'tile-portrait');
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
      });
      bg_observer.observe(element);
      element._bg_observer = bg_observer;
    }
  }]);
}();
module.exports = CallInterfaceVideo;